import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html'
})
export class SupportComponent {}
